// extracted by mini-css-extract-plugin
module.exports = {"rules":"styles_rules__HIVCg","more":"styles_more__uRzqt"};